var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 40,
    viewBox: "0 0 16.363 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M668.181-8168h0a27.356,27.356,0,0,1-4.089-3.523,18.318,18.318,0,0,1-2.812-3.764,9.493,9.493,0,0,1-1.278-4.53,8.191,8.191,0,0,1,8.181-8.183,8.192,8.192,0,0,1,8.183,8.183,9.492,9.492,0,0,1-1.279,4.53,18.326,18.326,0,0,1-2.813,3.764,27.361,27.361,0,0,1-4.09,3.523ZM668-8183a3,3,0,0,0-3,3,3,3,0,0,0,3,3,3,3,0,0,0,3-3A3,3,0,0,0,668-8183Z",
    transform: "translate(-657 8189)",
    fill: "#00246A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinDark);
export default __webpack_public_path__ + "static/media/map-pinDark.36c48274c3e57f4db13591bc365294cf.svg";
export { ForwardRef as ReactComponent };